/**
 * Agencies - Contracts Page
 * Manage recurring contracts for agency projects
 */

import { useEffect } from 'react';
import { MainLayout } from "@/components/MainLayout";
import { AllContractsPage } from '@/components/industry/pages/AllContractsPage';
import { CompanyType } from '@/types/company';

export default function AgenciesContractsPage() {
  useEffect(() => {
    document.title = 'Contratos | Controle Financeiro';
  }, []);

  return (
    <MainLayout>
      <AllContractsPage
        domain={CompanyType.AGENCIES}
        pageTitle="Contratos de Projetos"
        pageDescription="Gerencie contratos recorrentes e pagamentos de clientes"
      />
    </MainLayout>
  );
}

